import { render, staticRenderFns } from "./RemoveEntityModal.vue?vue&type=template&id=3bc0ad18&scoped=true&"
import script from "./RemoveEntityModal.vue?vue&type=script&lang=js&"
export * from "./RemoveEntityModal.vue?vue&type=script&lang=js&"
import style1 from "./RemoveEntityModal.vue?vue&type=style&index=1&id=3bc0ad18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0ad18",
  null
  
)

export default component.exports